__turbopack_context__.v({
  "cardPagination": "CardPagination-module__2dm6qW__cardPagination",
});
